export const scrollFunc = (smth: string, isMobile: boolean) => {
  let top: number;

  switch (smth) {
    case 'О конкурсе':
      top = 0;
      break;
    case 'Тайминг':
      top = isMobile ? 700 : 1100;
      break;
    case 'Условия и требования':
      top = isMobile ? 1200 : 1600;
      break;
    case 'Жюри и оценивание проектов':
      top = isMobile ? 2100 : 2700;
      break;
    case 'Вознаграждение':
      top = isMobile ? 6500 : 3850;
      break;
    case 'Контакты':
      top = isMobile ? 7000 : 5650;
      break;
    default:
      return;
  }

  window.scrollTo({ top, behavior: 'smooth' });
};
export const scrollFunc = (smth: string, isMobile: boolean) => {
  let top: number;

  switch (smth) {
    case 'О конкурсе':
      top = 0;
      break;
    case 'Тайминг':
      top = isMobile ? 700 : 1100;
      break;
    case 'Условия и требования':
      top = isMobile ? 1200 : 1600;
      break;
    case 'Жюри и оценивание проектов':
      top = isMobile ? 2100 : 2700;
      break;
    case 'Вознаграждение':
      top = isMobile ? 6500 : 3850;
      break;
    case 'Контакты':
      top = isMobile ? 7000 : 5650;
      break;
    default:
      return;
  }

  window.scrollTo({ top, behavior: 'smooth' });
};
